import { StreamingType } from '@/graphql/generated/schemas'

// The video wall opens as a full-screen overlay that must sit above all app
// chrome, Chakra modals/popovers, and the emergency-call container (z-index
// 1401), so we place it well above them.
export const VIDEO_WALL_Z_INDEX = 2000

// Global keyboard shortcut (pressed anywhere outside a text field) that toggles
// the video wall overlay.
export const VIDEO_WALL_SHORTCUT_KEY = 'w'

// The wall is a fixed 2-row × 3-column grid (6 cells). Used for the CSS grid
// template; the cell count itself lives with the redux state (VIDEO_WALL_CELL_COUNT).
export const VIDEO_WALL_ROWS = 2
export const VIDEO_WALL_COLS = 3

// The video wall only shows cloud cameras. These are the StreamingType values we
// treat as "cloud" (Verkada / Ava / Avigilon / Arcules) — on-prem/ExacqVision are
// excluded.
export const CLOUD_STREAMING_TYPES: StreamingType[] = [
  StreamingType.VerkadaCloud,
  StreamingType.AvaCloud,
  StreamingType.AvigilonCloud,
  StreamingType.ArculesCloud,
]

// Mixpanel event names for the video wall. Feature-scoped (mirrors FTU_ANALYTICS)
// so we don't touch the global analytics barrel. Property keys passed alongside
// these follow lower_snake_case (e.g. camera_id, streaming_type).
export const VIDEO_WALL_ANALYTICS = {
  opened: 'Video Wall Opened',
  closed: 'Video Wall Closed',
  cameraAdded: 'Video Wall Camera Added',
  cameraRemoved: 'Video Wall Camera Removed',
} as const
